import type { QuotationLineItem } from "@/mocks/quotationsData";
import { computeSubtotal, computeTaxTotal, computeTotal } from "@/mocks/quotationsData";

type Props = {
  items: QuotationLineItem[];
  discount: number;
  onDiscountChange: (v: number) => void;
};

export function QuotationTotals({ items, discount, onDiscountChange }: Props) {
  const subtotal = computeSubtotal(items);
  const taxTotal = computeTaxTotal(items);
  const total = computeTotal(items, discount);

  return (
    <div className="flex justify-end">
      <div className="w-full max-w-xs space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-gray-500">Subtotal</span>
          <span className="font-medium text-gray-900">₹{subtotal.toLocaleString("en-IN")}</span>
        </div>

        <div className="flex justify-between items-center text-sm">
          <span className="text-gray-500">Discount</span>
          <div className="flex items-center gap-1">
            <span className="text-gray-400">-₹</span>
            <input
              type="number"
              value={discount || ""}
              onChange={(e) => onDiscountChange(Math.max(0, parseFloat(e.target.value) || 0))}
              placeholder="0"
              className="w-24 px-2 py-1 text-sm text-right border border-gray-200 rounded-md focus:border-indigo-300 focus:ring-1 focus:ring-indigo-100 outline-none"
              min={0}
            />
          </div>
        </div>

        <div className="flex justify-between text-sm">
          <span className="text-gray-500">Tax Total</span>
          <span className="font-medium text-gray-900">₹{taxTotal.toLocaleString("en-IN")}</span>
        </div>

        <hr className="border-gray-200" />

        <div className="flex justify-between">
          <span className="text-base font-semibold text-gray-900">Total</span>
          <span className="text-xl font-bold text-indigo-600">₹{total.toLocaleString("en-IN")}</span>
        </div>
      </div>
    </div>
  );
}